import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            焦点推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2">编辑精选，不可错过的热门好剧</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-semibold text-primary-600">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <p className="text-xs text-accent-600 font-semibold mb-1">{item.subtitle}</p>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}